var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTouched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M67.61 66.914c1.275 0 2.308 1.033 2.308 2.307 0 1.195-.908 2.178-2.072 2.296l-.236.012H32.09c-1.274 0-2.308-1.033-2.308-2.308 0-1.195.908-2.177 2.072-2.295l.236-.012h35.52zM49.453 3.562c4.75-4.75 12.45-4.75 17.2 0 4.749 4.75 4.749 12.45 0 17.2l-44.13 44.13c-.296.295-.667.505-1.073.606L2.87 70.143c-1.69.423-3.222-1.108-2.799-2.798l4.645-18.581c.102-.406.312-.776.607-1.072zm12.769 4.43c-2.824-2.824-7.402-2.824-10.225 0l-41.85 41.85L6.74 63.474l13.634-3.41 41.849-41.847c2.73-2.73 2.82-7.098.273-9.937z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V72H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTouched);
export default __webpack_public_path__ + "static/media/edit-touched.e1359d8c8e03cc46e8bc2d654871464d.svg";
export { ForwardRef as ReactComponent };